import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "icon", "overlay"];

  toggle() {
    this.menuTarget.classList.toggle("-translate-x-full");
    this.overlayTarget.classList.toggle("hidden");
    this.toggleIcon();
  }

  close() {
    if (!this.menuTarget.classList.contains("-translate-x-full")) {
      this.menuTarget.classList.add("-translate-x-full");
      this.overlayTarget.classList.add("hidden");
      this.toggleIcon();
    }
  }

  toggleIcon() {
    this.iconTarget.classList.toggle("fa-bars");
    this.iconTarget.classList.toggle("fa-xmark");
    this.iconTarget.classList.add("fasr");
  }
}
